import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import { STREAK_STEP } from '@/helpers/constants';
import { MyTooltip } from '@/webkit/MyTooltip';
import { useGetMilestoneRewards } from '@/query/queries/streak/useGetMilestoneRewards';
import IconCheck from './icon_check.svg';
import IconGift from './icon_gift.svg?react';
import s from './index.module.scss';

export const MilestoneProgress = ({ status }) => {
  const { t } = useTranslation('streak');
  const { data: rewards } = useGetMilestoneRewards();

  const gift = useMemo(() => {
    if (!rewards || !status) return null;
    return rewards?.find(i => i.milestone === status.current_milestone) || null;
  }, [rewards]);

  if (!status) return null;

  const progressStreak =
    status.streak <= status.max_milestone
      ? status.streak
      : status.max_milestone;

  return (
    <div className={s.wrapper}>
      <div className={s.segments}>
        {new Array(3).fill('').map((item, index) => (
          <div
            key={index}
            className={classnames(
              s.segment,
              (index + 1 <= progressStreak % STREAK_STEP ||
                progressStreak === status.current_milestone) &&
                s.segment_filled,
            )}
          >
            {index + 1 === progressStreak % STREAK_STEP &&
              progressStreak !== status.current_milestone && (
                <div className={classnames(s.circle, s.circle_check)}>
                  <img src={IconCheck} alt="check" width={20} height={20} />
                </div>
              )}

            {gift &&
              index + 1 ===
                (status.current_milestone % STREAK_STEP) + STREAK_STEP && (
                <div className={s.circle}>
                  <MyTooltip
                    theme="dark"
                    renderElement={() => (
                      <div className={s.circle_tooltip}>
                        <IconGift
                          className={classnames(
                            s.gift,
                            progressStreak === status.current_milestone &&
                              s.gift_earned,
                          )}
                        />
                      </div>
                    )}
                    renderContent={() => (
                      <div className="f-small-regular">
                        {t('tooltip.gift', {
                          income_increase: `+${gift.income_increase.toFixed(2)}%`,
                          net_cash_flow: `${gift.net_cash_flow_bonus.toFixed(2)}%`,
                        })}
                      </div>
                    )}
                  />
                </div>
              )}
          </div>
        ))}
      </div>
      <div className={s.bottom}>
        <div className="f-body-regular">
          {t('milestone_progress.milestone_progress')}
        </div>
        <div className="f-body-accent">
          {t('milestone_progress.invested_in', {
            streak: progressStreak,
            current_milestone: status.current_milestone,
          })}
        </div>
      </div>
    </div>
  );
};
